import { render, staticRenderFns } from "./textbox.vue?vue&type=template&id=23fd2dcc&"
import script from "./textbox.vue?vue&type=script&lang=js&"
export * from "./textbox.vue?vue&type=script&lang=js&"
import style0 from "./textbox.vue?vue&type=style&index=0&id=23fd2dcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports